export default new Map() as Map<string, string | null | undefined>;
